<template>
  <!--  modal-->
  <div dir="ltr" class="container yekanbakhfanumbold-font">
    <div class="modal fade" id="create-project-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close text-right p-3" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="text-center">
            <h3 class=" text-center p-2 text-dark">
              <span class="caption-name">ساخت پروژه جدید</span>
            </h3>
          </div>
          <div class="form-group p-2 m-0">
            <label for="userName" class="p-1 m-0 ">نام کاربر</label>
            <div class="row mx-auto justify-content-center">
              <div class="col-3">
                <button type="submit" class="btn btn-secondary col-12 " @click="getUsers">جست و جو</button>
              </div>
              <input @click="showUsers" id="userName" v-model="searchWords" placeholder="لطفا نام کاربر را وارد کنید"
                     class="form-control text-center col-9"/>

            </div>
            <div v-if="showUserList" class="user-list form-group px-3 ">
              <div
                  class="user-list-item yekanbakhfanumbold-font form-control text-center"
                  v-for="(user, index) in searchResults" :key="user.id"
                  @click="selectUser(user)"
              >
                {{ user.name }} {{ user.last_name }}
              </div>
            </div>
          </div>


          <form @submit.prevent="submit">


            <div class="form-group p-2 m-0 yekanbakhfanumbold-font">
              <label for="projectName" class="p-1 m-0">نام پروژه</label>
              <input v-model="form.name" id="projectName" dir="ltr" type="text" class="form-control text-left"
                     placeholder="mixitweb">
            </div>

            <div class="form-group p-2 m-0">
              <label for="domain" class="p-1 m-0 ">دامنه</label>
              <input v-model="form.domain" id="domain" dir="ltr" type="url" class="form-control text-left "
                     placeholder="https://mixitweb.ir/">
            </div>

            <div class="form-group p-2 m-0">
              <label for="dashboardLink" class="p-1 m-0">لینک داشبورد</label>
              <input v-model="form.dashboard_url" id="dashboardLink" dir="ltr" type="url" class="form-control text-left"

                     placeholder="https://dash.mixitweb.ir/">
            </div>
            <div class="form-group p-2 m-0">
              <label for="apiLink" class="p-1 m-0 ">api لینک</label>
              <input v-model="form.api_url" id="apiLink" dir="ltr" type="url" class="form-control text-left"

                     placeholder="https://api.mixitweb.ir">
            </div>
            <div class="row mx-auto">
              <div class="col-6 mx-auto text-left">
                <button type="submit" class="btn btn-secondary m-2 col-12">ثبت</button>
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>

</template>


<script>

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "CreatProject",
  data() {
    return {
      form: {
        domain: "",
        name: "",
        dashboard_url: "",
        api_url: "",
        user_id: "",
      },
      names: '',
      searchResults: [],
      searchWords: '',
      selectedUser: "",  // مقدار انتخاب‌شده
      showUserList: false, // کنترل نمایش لیست

    }

  },

  computed: {},
  methods: {
    async getUsers() {
      this.$store.commit('ProjectAlpha/setFilters', {key: 'search', value: this.searchWords});
      let results = await this.$store.dispatch("ProjectAlpha/getPersons");
      this.searchResults = results.data.data.data;
    },

    selectUser(user) {
      this.searchWords = `${user.name} ${user.last_name}`;
      this.showUserList = false;
      this.form.user_id = user.id;
    },
    showUsers() {
      this.showUserList = true;

    },
    submit() {
      console.log(this.form)
      let response = this.$store.dispatch('ProjectAlpha/creatProject', this.form);

      response.then((res) => {
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        this.$store.dispatch('ProjectAlpha/setProjects');
      })
          .catch((error) => {
            toast('عملیات انجام نشد', 'عملیات انجام نشد', 'danger')

            console.log(error);
          })
    }
  }
}


</script>


<style scoped>
.caption-name {
  border-bottom: 1px solid var(--secondary);


}

.user-list {
  overflow-y: auto;
  height: 150px;
}

.user-list-item {
  cursor: pointer;
}

.user-list-item:hover {
  background: #eb3d60;
  color: white;
}

</style>